import axios from "axios";
import {
  getStorefrontHeaders,
  storefrontIdentity,
} from "../config/storefrontRuntime";
import { getStorefrontActivityHeaders } from "../utils/storefrontActivityIdentity";
import { notifyServiceUnavailable } from "../utils/serviceAvailability";

/**
 * Producción recomendada:
 *   REACT_APP_API_URL=https://tu-backend.onrender.com/api
 *
 * Desarrollo local opcional:
 *   REACT_APP_API_URL_LOCAL=http://localhost:4001/api
 *   REACT_APP_PROJECT_SLUG=slug-del-proyecto
 *
 * En producción no hace falta hardcodear el slug: el backend resuelve el
 * proyecto usando el dominio real enviado por el storefront.
 */
const rawBaseURL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_API_URL || "/api"
    : process.env.REACT_APP_API_URL_LOCAL ||
      process.env.REACT_APP_API_URL ||
      "http://localhost:4001/api";

const baseURL = String(rawBaseURL).replace(/\/+$/, "");
const projectSlug = storefrontIdentity.projectKey;

const api = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 20000,
});

api.interceptors.request.use((config) => {
  config.headers = config.headers || {};

  const identityHeaders = {
    ...getStorefrontHeaders(),
    ...getStorefrontActivityHeaders(),
  };
  Object.entries(identityHeaders).forEach(([name, value]) => {
    if (value && !config.headers[name]) config.headers[name] = value;
  });

  if (process.env.NODE_ENV !== "production") {
    console.log("[Storefront API →]", {
      method: String(config.method || "GET").toUpperCase(),
      url: `${config.baseURL || ""}${config.url || ""}`,
      params: config.params,
      identity: storefrontIdentity,
    });
  }

  return config;
});

api.interceptors.response.use(
  (response) => {
    if (process.env.NODE_ENV !== "production") {
      console.log("[Storefront API ←]", {
        status: response.status,
        url: response.config?.url,
      });
    }
    return response;
  },
  (error) => {
    notifyServiceUnavailable(error);

    const status = error?.response?.status;
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Error de conexión con el servidor";

    if (process.env.NODE_ENV !== "production") {
      console.error("[Storefront API ✕]", {
        baseURL,
        url: error?.config?.url,
        method: error?.config?.method,
        status,
        message,
        identity: storefrontIdentity,
      });
    }

    return Promise.reject(error);
  }
);

export { baseURL, projectSlug, storefrontIdentity };
export default api;
